module.exports = __webpack_public_path__ + "img/hand.9f8a3b2a.svg";